import styled from 'styled-components';
import { Card } from '@mews-commander/ui';
import { getSpacingToken, getToken } from '@optimus-web/core';
import { COLOR_GRAY, COLOR_WHITE, COLOR_ACTIONABLE } from '../../../components/commander-ui/constants';

interface MessageProps {
    fromEmployee?: boolean;
}

export const MessageElement = styled.div<MessageProps>`
    white-space: pre-line;
    display: flex;

    margin-top: 16px;
    &:first-child {
        margin-top: 0;
    }

    flex-direction: row;
    ${(props) =>
        props.fromEmployee &&
        `
        flex-direction: row-reverse;
    `}
`;

export const UserImageContainer = styled.div<MessageProps>`
    margin: 0px 8px 0px 0px;
    ${(props) =>
        props.fromEmployee &&
        `
        margin: 0px 0px 0px 8px;
    `}
`;

export const MessageBody = styled.div<MessageProps>`
    padding: 8px;
    color: ${COLOR_WHITE};
    border-radius: 4px;
    flex: 1 1;
    word-break: break-word;

    background: ${COLOR_GRAY};
    ${(props) =>
        props.fromEmployee &&
        `
        background: ${COLOR_ACTIONABLE};
    `}
`;

export const MessageHeading = styled.h5`
    margin-top: 0px;
    margin-bottom: ${getSpacingToken('100')}px;

    & > small {
        color: inherit;
    }
`;

export const MessengerFooter = styled.div`
    margin-top: ${getSpacingToken('100')}px;
`;

export const MessageResendWrapper = styled.div`
    margin-top: 16px;
`;

interface BlockWrapperProps {
    isSmall?: boolean;
    isActive?: boolean;
}

const BlockWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
`;

export const ThreadsBlockWrapper = styled(BlockWrapper)<BlockWrapperProps>`
    width: 25%;
    position: relative;

    ${(props) => props.isSmall && `width: 100%;`}
`;

export const MembersBlockWrapper = styled(BlockWrapper)<BlockWrapperProps>`
    width: 25%;
    z-index: 101;

    ${({ theme, isSmall }) =>
        isSmall &&
        `
            width: 100%;
            position: absolute;
            background: ${getToken('backgroundStaticFlat')({ theme })};
            left: 100%;
            top: 0;
    `}

    ${(props) => props.isActive && `left: 0;`}
`;

export const MessagesBlockWrapper = styled(BlockWrapper)<BlockWrapperProps>`
    z-index: 100;
    width: 50%;
    padding: 0 10px;

    ${({ theme, isSmall }) =>
        isSmall &&
        `
            width: 100%;
            position: absolute;
            background: ${getToken('backgroundStaticFlat')({ theme })};
            left: 100%;
            top: 0;
            padding: 0;
        `}

    ${(props) => props.isActive && `left: 0;`}
`;

export const PanelCard = styled(Card)`
    flex-shrink: 1;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    margin: 0;
    overflow: hidden;
`;

export const PanelBodyElement = styled.div`
    flex-grow: 1;
    overflow-y: auto;
    padding: 16px;
`;

export const UlElement = styled.ul`
    padding: 0;
    overflow-y: auto;
    margin: 0;
`;

export const MessagesWrapperElement = styled.div`
    overflow: hidden;
    width: 100%;
    display: flex;
    flex-direction: row;
`;

export const MessagesContainerElement = styled.div`
    display: flex;
    overflow: hidden;
    position: absolute;
    left: 10px;
    right: 10px;
    top: 10px;
    bottom: 10px;
`;
